const resetData = (context: any) => {
  context.page = {
    IncidentsPage: null,
    DraftsPage: null,
    EnforcementContactsPage: null
  }
  sessionStorage.removeItem('IncidentsPage')
  sessionStorage.removeItem('DraftsPage')
  sessionStorage.removeItem('EnforcementContactsPage')
}

export default resetData
